<p-toast />

<div class="tracking-shell">
  @if(!expirado()) {
  <header class="card header">
    <div class="header__text">
      <h3>Entrega de Equipamentos</h3>
      <p class="subtitle">
        Os equipamentos do seu Sistema Solar estão a caminho.
      </p>
    </div>
    <div class="header__pill">
      @if (motoristaChegou()) {
      <span class="status-pill status-pill--chegou">🚚 Sua entrega chegou!</span>
      } @else {
      <span class="status-pill">{{ rastreio()?.status || 'Carregando' }}</span>
      }
    </div>
  </header>
  }

  @if (loading()) {
  <div class="card"><p>Localizando veículo de entrega...</p></div>
  } @else if (expirado()) {
  <div class="card error">
    <h3>Entrega Finalizada ou Link Expirado</h3>
    <p>Este link não está mais ativo. A entrega já foi concluída com sucesso ou
      o acesso expirou.</p>
  </div>
  } @else {
  <div class="card-info info">
    <div class="text-md pb-2">
      Olá, <strong>{{ rastreio()?.cliente }}</strong>!
    </div>
    <small class="text-gray-500 pb-4">
      Os equipamentos do seu sistema solar estão a caminho, em breve o
      motorista
      entrará em contato para realizar a entrega.
    </small>
    <small class="pb-1">
      Nota Fiscal: <strong>{{ rastreio()?.numeroNotaFiscal }}</strong>
    </small>
    <small class="pb-4">
      Motorista: <strong>{{ rastreio()?.motorista }}</strong>
    </small>
    <small class="pb-1">
      Código de Entrega: <strong>{{ rastreio()?.codigoRastreio }}</strong>
    </small>
    <small class="text-red-500">
      <strong>O código de entrega deve ser informado ao motorista no ato da
        entrega dos equipamentos.</strong>
    </small>
  </div>

  <div #mapContainer class="map-view"></div>
  }
</div>